<template>
  <div>
    <app-layout v-if="$store.state.initialized">
      <router-view></router-view>
      <v-snackbar v-model="$store.state.errorSnackbarVisible" bottom color="error" timeout="60000">
        {{ $store.state.errorSnackbarContent }}

        <template v-slot:action="{ attrs }">
          <v-btn
            small
            icon
            outlined
            v-bind="attrs"
            @click="
              $store.commit('SET', { errorSnackbarVisible: false, errorSnackbarContent: null })
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </app-layout>
  </div>
</template>

<script>
import syncFromQueryParams from "@/actions/syncFromQueryParams";
import updateRouteQuery from "@/actions/updateRouteQuery";
import AppLayout from "./components/layouts/AppLayout";
import injectables from "@/common/injectables";
import { steps } from "@/components/stepper/stepper";

export default {
  components: {
    AppLayout,
  },

  created() {
    this.initApp();
  },

  data() {
    return {
      startWatchingForChanges: false,
    };
  },

  computed: {
    stepIndex() {
      return steps.findIndex((item) => item.component === this.$store.state.step);
    },
    apartmentId() {
      return this.$store.state.apartment_id;
    },
    email() {
      return this.$store.state.email;
    },
  },

  watch: {
    stepIndex(step) {
      updateRouteQuery(this.$route, { step });
    },
    apartmentId(apartmentId, oldApartmentId) {
      if (this.startWatchingForChanges) this.$store.dispatch("resetSelection", this);
    },
    email(email, oldEmail) {
      if (this.startWatchingForChanges) this.$store.dispatch("resetSelection", this);
    },
  },

  methods: {
    async initApp() {
      let data = injectables;
      if (!data) {
        const response = await this.axios.post("init", this.$route.query);
        data = response.data;
      }

      await this.$i18n.setLocaleMessage(data.locale, data.translations);
      this.$i18n.locale = data.locale;
      this.$vuetify.lang.current = data.locale;

      const updatables = {};
      ["is_admin", "apartments", "buildings", "options"].forEach((key) => {
        if (_.has(data, key)) updatables[key] = data[key];
      });

      this.$store.commit("SET", updatables);

      if (this.$route.name === "Success") {
        this.$router.push({ name: "Stepper", query: this.$route.query });
      }

      if (this.$route.name === "Stepper") {
        if (!data.selection) {
          // If there were no selection then apartment_id or email must be
          // missing. Anyways, it's a good reason to return home.
          this.$router.push({
            name: "Home",
            query: this.$route.query,
          });
        } else {
          this.handleStepperInit(data.selection);
          this.$store.dispatch("setFromDatabase", data.selection);
        }
      }

      this.$store.commit("SET", { initialized: true });
      setTimeout(() => {
        this.startWatchingForChanges = true;
      }, 500);
    },

    handleStepperInit(selectionFromDatabase) {
      if (!selectionFromDatabase || !this.routeHasEachRequiredField()) {
        this.$router.push({ name: "Home", query: this.$router.query });
      } else {
        syncFromQueryParams(this.$route);
      }
    },

    routeHasEachRequiredField() {
      for (const field of ["apartment_id", "email", "tel"]) {
        if (!this.$route.query.hasOwnProperty(field) || !this.$route.query[field]) return false;
      }

      return true;
    },
  },
};
</script>
